import { RouteConfig } from "vue-router";
import DashboardComponent from "./dashboard.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/customer-support/dashboard",
    component: DashboardComponent,
    meta: {
      roles: [Roles.CustomerSupport],
      nav: true,
      navTitle: "Dashboard",
      navIcon: "fa-users"
    }
  }
] as RouteConfig[];